import ProductCardWithSelectableRatePlan from './ProductCardWithSelectableRatePlan';
export default ProductCardWithSelectableRatePlan;
